import { AUTH_BASE_URL } from "../constants/constants";
import { sendRequest } from "../utils/sendAPI";
import { getToken } from "./authApi";

export const getCustomerById = async (id) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/customers/${id}`,
      method: "GET",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching customer:", err);
    throw err;
  }
};

export const getCustomers = async ({ page, size, keyword, level }) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const params = new URLSearchParams({
      page: page,
      size: size,
    });

    if (keyword) params.append("keyword", keyword);
    if (level) params.append("level", level);
    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/customers?${params.toString()}`,
      method: "GET",
      token: token,
    });

    return res;
  } catch (err) {
    console.error("Error fetching customer:", err);
    throw err;
  }
};

export const createCustomer = async (body) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/customers/create`,
      method: "POST",
      body: body,
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error creating customer:", err);
    throw err;
  }
};

export const updateCustomer = async (id, body) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/customers/${id}`,
      method: "PUT",
      body: body,
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error updating customer:", err);
    throw err;
  }
};

export const deleteCustomer = async (id) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/customers/${id}`,
      method: "DELETE",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error deleting customer:", err);
    throw err;
  }
};
